import React from 'react';
import classNames from 'classnames';
import './brRadioButton.scss';

interface BrRadioButtonProps {
  onClick: any;
  className?: string;
  id: any;
  name?: string;
  isSelected: boolean;
  label: string;
  description?: string;
  isDisabled?: boolean;
}
export default function BrRadioButton(props: BrRadioButtonProps) {
  const { onClick, className, id, isSelected, label, description, isDisabled = false } = props;
  return (
    <div
      className={classNames('br-radio-button', className, isDisabled && 'disabled')}
      onClick={isDisabled ? () => undefined : onClick}
    >
      <input id={id} type="radio" checked={isSelected} readOnly />
      <div>
        <label htmlFor={id} className="br-rb-label">
          {label}
        </label>
        {description && <div className="br-rb-description">{description}</div>}
      </div>
    </div>
  );
}
